<template>
  <div>
    <div class="report-cell" v-for="(item, index) in list" :key="index">
      <a :href="'/report/chinese/'+item.id" target="_blank" class="report-cell-title">
        <span>{{ item.product_name }}</span>
        <img :src="item.product_class.small_icon.img" v-if="item.product_class && item.product_class.small_icon && item.product_class.small_icon.img" />
      </a>
      <div class="report-cell-desc">
        {{ removeHtmlTags(item.content) }}
      </div>
      <div class="report-cell-tag">
        <span>{{ $moment(item.publish_time).format("YYYY-MM-DD") }}</span>
        <span v-if="item.author">{{ item.author }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportCell',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {};
  },
  methods: {
    removeHtmlTags(value) {
      return value ? value.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, '').replace(/^\s+|\s+$/g, '') : "";
    },
  }
}
</script>
<style lang="scss" scoped>
.report-cell {
  padding: 24px 0;
  border-top: 1px solid #e9e9e9;
  font-family: HarmonyOS_Sans_Regular;
  &-title {
    font-size: 22px;
    text-decoration: none;
    color: #231815;
    display: inline-block;
    span {
      cursor: pointer;
      margin-right: 10px;
      font-family: HarmonyOS_Bold;
      &:hover {
        color: #ed6f33;
      }
    }
    img {
      max-height: 26px;
      display: inline-block;
      vertical-align: sub;
    }
  }
  &-desc {
    position: relative;
    margin: 35px 0;
    font-size: 14px;
    color: #909399;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    line-height: 30px;
    max-height: 90px;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }
  &-tag {
    font-size: 12px;
    font-family: HarmonyOS_Bold;
    color: #747474;
    span {
      &:before {
        content: "|";
        font-family: HarmonyOS_Sans_Regular;
        margin: 0 20px;
      }
      &:first-child {
        &:before {
          content: "";
          margin: 0;
        }
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .report-cell {
    &-title {
      font-size: 18px;
    }
  }
}
</style>
